import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

import HYGothicL from "../resources/HYGothicL.woff";
import HYGothicM from "../resources/HYGothicM.woff";
import HYGothicB from "../resources/HYGothicB.woff";

const GlobalStyle = createGlobalStyle`
    :root{
        --headerBgColor:rgba(249, 87, 89, 1);
        --hyGothic:HYGothicL;
        --fontBoxBorder: 1px solid #dadce0;
        --mintColor:#2ec0a9;
    }
    ${reset};
    a{
        text-decoration:none;
        color:inherit;
    };
    *{
        scroll-snap-type: none;
        box-sizing:border-box;
    };
    body{
        font-family:HYGothicL,-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        font-size:12px;
        background-color:#ffffff;
        color:#000000;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    };
    @media print {    
    .no-print, .no-print *
        {
            display: none !important;
        }
    }

    @link-color: #00;

 
    @font-face {
        font-family: 'HYGothicL';
        src: url(${HYGothicL}) format('woff');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'HYGothicM';
        src: url(${HYGothicM}) format('woff');
        font-weight: normal;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'HYGothicB';
        src: url(${HYGothicB}) format('woff');
        font-weight: normal;
        font-style: normal;
    }

    
    ${(props) =>
        props.data?.webFontList.map(
            (f) => `
        @font-face {
            font-family: '${f.webfontname}';
            src:url('http://font.fontbada.co.kr/fonts/index.php?name=${f.webfontname}');
        }`
        )}

      
`;

export default GlobalStyle;
